import Date                             from "../../../domain/fundamentals/date/Date";
import FetchStatusRepository            from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository                 from "../../../domain/fundamentals/message/notify/NotifyRepository";
import { ReservationSettingRepository } from "../../../domain/reservation/ReservationSettingRepository";
import FetchStatusDataSource            from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource                 from "../../../infrastructure/datasource/notify/NotifyDataSource";
import ReservationSettingDataSource
                                        from "../../../infrastructure/datasource/reservation/ReservationSettingDataSource";
import GetReservationSetting            from "./GetReservationSetting";

class DeleteReservationSpecialTime {
  constructor(
    private readonly dispatch,
    private readonly getReservationSetting: GetReservationSetting = new GetReservationSetting(dispatch),
    private readonly reservationSettingRepository: ReservationSettingRepository = new ReservationSettingDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch)
  ) {
  }

  public async execute(index: number, date: Date) {
    this.fetchStatusRepository.start();
    try {
      await this.reservationSettingRepository.deleteSpecialBusinessTime(index, date);
      await this.getReservationSetting.execute();
      this.notifyRepository.deleteSuccess();
    } catch (e) {
      this.notifyRepository.deleteFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default DeleteReservationSpecialTime;
